import {Col, Row} from "react-bootstrap";
import React from "react";

// export function PageTitle({title, children}) {
//     return <Row className="d-sm-inline text-center pt-1">
//         <Col className="p-0" md={{span: 8, offset: 2}}>
//             <h3 className="d-none d-sm-block text-capitalize">{title}</h3>
//             <h5 className="d-sm-none text-capitalize">{title}</h5>
//             <p className="d-none d-sm-inline text-capitalize">{children}</p>
//         </Col>
//     </Row>
// }

export function PageTitle({title, children}) {
    return <div className="d-flex flex-column justify-content-center align-items-center text-capitalize p-1">
        <div className="fs-3 fw-semibold d-none d-md-block mb-1">{title}</div>
        <div className="fs-4 fw-semibold d-md-none">{title}</div>
        <div className="mb-1">{children}</div>
    </div>
}
